"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AppSwitcher_exports = {};
__export(AppSwitcher_exports, {
  default: () => AppSwitcher_default
});
module.exports = __toCommonJS(AppSwitcher_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("g", { clipPath: "url(#clip0_3930_8976)", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M31.4815 0C31.7679 0 32 0.232149 32 0.518519V31.4815C32 31.7679 31.7679 32 31.4815 32H0.518519C0.232149 32 0 31.7679 0 31.4815V0.518519C0 0.232149 0.232149 0 0.518519 0H31.4815ZM30.963 1.03704H1.03704V30.963H30.963V1.03704ZM26.5256 16.963C27.4369 16.963 27.7818 17.4944 27.8589 17.9102L27.128 18.1109C27.1023 17.9455 26.9632 17.6647 26.5206 17.6647C26.2167 17.6647 26.0214 17.8502 26.0214 18.0456C26.0214 18.2163 26.1294 18.3412 26.3815 18.3863L26.8708 18.4766C27.5655 18.6021 27.9259 19.038 27.9259 19.5441C27.9259 20.1003 27.4471 20.6667 26.5771 20.6667C25.5683 20.6667 25.1358 20.0301 25.0844 19.529L25.8309 19.3537C25.8617 19.6795 26.0881 19.9652 26.5876 19.9652C26.9067 19.9652 27.1023 19.8149 27.1023 19.5945C27.1023 19.414 26.9527 19.2835 26.7108 19.2384L26.2119 19.1484C25.594 19.0328 25.2184 18.6321 25.2184 18.1056C25.2184 17.4341 25.8255 16.963 26.5256 16.963ZM5.4309 17.0384L6.4346 19.439L7.38685 17.0384H8.5039V20.5915H7.70628V18.2364L6.75371 20.5915H6.09485L5.14259 18.2664V20.5915H4.37037V17.0384H5.4309ZM11.8125 17.0381V20.5915H10.9889V17.0381H11.8125ZM15.27 17.0384L16.6392 19.1985V17.0384H17.4524V20.5915H16.5932L15.09 18.2559V20.5915H14.2819V17.0384H15.27ZM21.2554 17.0384C22.3518 17.0384 23.0878 17.7198 23.0878 18.8173C23.0878 19.9151 22.3518 20.5915 21.25 20.5915H19.9322V17.0384H21.2554ZM21.217 17.7147H20.7454V19.8808H21.217C21.775 19.8808 22.2304 19.5483 22.2304 18.8C22.2304 18.0521 21.775 17.7147 21.217 17.7147ZM6.15676 11.3333C7.22105 11.3333 7.7139 11.935 7.87624 12.4308L7.0794 12.6967C7.02184 12.476 6.77541 12.0753 6.15676 12.0753C5.65356 12.0753 5.0611 12.3959 5.0611 13.1877C5.0611 13.9296 5.57498 14.3152 6.17778 14.3152C6.79093 14.3152 7.04803 13.9346 7.09525 13.7342H5.97857V13.0624H7.87107V14.9619H7.20003L7.14764 14.6011C6.98497 14.8268 6.63409 15.037 6.10437 15.037C5.07145 15.037 4.22222 14.3105 4.22222 13.1877C4.22222 12.0701 5.108 11.3333 6.15676 11.3333ZM11.7958 11.4088C12.5295 11.4088 13.0017 11.8898 13.0017 12.5214C13.0017 13.0025 12.7236 13.3682 12.2676 13.5237L13.0227 14.9619H12.1104L11.4446 13.639H11.1509V14.9619H10.3224V11.4088H11.7958ZM17.6922 11.4088V12.1554H16.1664V12.8321H17.5509V13.5287H16.1664V14.2104H17.6974V14.9619H15.3382V11.4088H17.6922ZM22.1298 11.4088L23.5139 14.9619H22.6123L22.3448 14.2403H20.9083L20.6409 14.9619H19.7706L21.1706 11.4088H22.1298ZM28.0741 11.4088V12.1653H26.9257V14.9619H26.0978V12.1653H24.9549V11.4088H28.0741ZM21.6369 12.2684L21.181 13.5595H22.0829L21.6369 12.2684ZM11.6219 12.108H11.1343V13.0149H11.6219C11.9625 13.0149 12.1461 12.8247 12.1461 12.5611C12.1461 12.2819 11.9625 12.108 11.6219 12.108Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("defs", { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("clipPath", { id: "clip0_3930_8976", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("rect", { width: 32, height: 32, fill: "white" }) }) })
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgAppSwitcher = SvgIcon;
var AppSwitcher_default = SvgAppSwitcher;
//# sourceMappingURL=AppSwitcher.js.map